<template>
  <!-- 你的模板放这里 -->
  <section
    class="courses container section"
    :style="{ paddingTop: '130px' }"
  >
    <h1 class="h1">課程列表</h1>

    <!-- 工具列 -->
    <div class="toolbar">
      <div class="select-wrap">
        <button class="select-btn" @click="open = !open">
          {{ currentCategoryLabel }}
          <svg viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"/></svg>
        </button>
        <ul v-if="open" class="select-menu">
          <li v-for="c in categories" :key="c">
            <button class="option" @click="choose(c)">
              {{ c }} courses…
            </button>
          </li>
        </ul>
      </div>

      <div class="search">
        <input
          v-model.trim="q"
          type="search"
          placeholder="Search courses…"
          @keydown.esc="q=''"
        />
        <svg viewBox="0 0 24 24" class="search-ic">
          <circle cx="11" cy="11" r="7" stroke-width="2" fill="none" />
          <path d="M16 16l5 5" stroke-width="2" />
        </svg>
      </div>
    </div>

    <!-- 卡片栅格 -->
    <div class="grid grid-2-lg cards">
      <CourseCard
        v-for="c in filtered"
        :key="c.id"
        :course="c"
      />
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import CourseCard from '@/components/CourseCard.vue'
import { courses, categories } from '@/data/courses'


// 下拉开合
const open = ref(false)
function onDocClick(e) {
  if (!e.target.closest('.select-wrap')) open.value = false
}
onMounted(() => document.addEventListener('click', onDocClick))
onBeforeUnmount(() => document.removeEventListener('click', onDocClick))

// 分类 + 搜索
const selected = ref('All')
const q = ref('')
const currentCategoryLabel = computed(() =>
  selected.value === 'All' ? 'All courses…' : selected.value + '…'
)
function choose(c) {
  selected.value = c
  open.value = false
}

const filtered = computed(() => {
  const text = q.value.toLowerCase()
  return courses.filter((c) => {
    const okCat = selected.value === 'All' || c.category === selected.value
    const okQ =
      !text ||
      c.title.toLowerCase().includes(text) ||
      c.desc.toLowerCase().includes(text)
    return okCat && okQ
  })
})
</script>

<style scoped>
/* 👇 把上次我给你的 hero 风格样式放这里（不要删 template/script） */
.course{
  display:flex;
  flex-direction:column;
  overflow:hidden;
  border-radius:16px;
  /* 玻璃肌理再加强一些 */
  background: rgba(255,255,255,.10);
  border: 1px solid rgba(255,255,255,.18);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: var(--shadow-card);
  color:#fff; /* 统一深色主题文字 */
}

.courses::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 0;
}

.courses :where(.h1, .toolbar, .cards) {
  position: relative;
  z-index: 1;
}

.h1 {
  margin-top: 0;
}

.toolbar {
  display: flex;
  gap: 14px;
  align-items: center;
  justify-content: flex-end;
  margin: 12px 0 18px;
  padding: 10px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

/* 下拉菜单与搜索等保留不变 */
.select-wrap {
  position: relative;
}
.select-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.92);
  color: #111;
  font-weight: 600;
  border: 1px solid #e5e7eb;
}
.select-btn svg {
  width: 18px;
  height: 18px;
  fill: #111;
}
.select-menu {
  position: absolute;
  right: 0;
  top: 110%;
  min-width: 190px;
  z-index: 10;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: var(--shadow-card);
  padding: 6px;
}
.option {
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  border-radius: 10px;
  color: #111;
  font-weight: 600;
}
.option:hover {
  background: #f5f5f5;
}

.search {
  position: relative;
}
.search input {
  width: 240px;
  max-width: 60vw;
  padding: 10px 36px 10px 12px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #111;
  outline: none;
}
.search-ic {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  stroke: #111;
  opacity: 0.7;
}

.cards {
  margin-top: 10px;
}


@media (min-width:1100px){
  .cards{
    display:grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap:24px;
    align-items: stretch;   /* ✅ 等高（默认就是 stretch，写上更明确） */
  }
}

</style>
